import { CapoPlugin } from "/builds/nht4944308/brands/umarketpro/webapp/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];